function cleanBaseUrl(value: string) {
  return value.replace(/\/+$/u, '')
}

const variables = import.meta.env ?? {}
const localHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)

export const platformEnv = {
  ssoApiUrl: cleanBaseUrl(variables.VITE_SSO_API_BASE_URL || 'https://api-sso.hocnhe.com'),
  ssoFrontendUrl: cleanBaseUrl(variables.VITE_SSO_FRONTEND_URL || 'https://sso.hocnhe.com'),
  paymentApiUrl: cleanBaseUrl(variables.VITE_PAYMENT_API_BASE_URL || 'https://account-payment-api.hocnhe.com'),
  affiliateFrontendUrl: cleanBaseUrl(variables.VITE_AGENT_FRONTEND_URL || (localHost ? 'https://localhost:5174' : 'https://agent.hocnhe.com')),
  googleClientId: variables.VITE_GOOGLE_CLIENT_ID || '541716939925-ftsktgf5culju42gl1qt96qvh39tf2p4.apps.googleusercontent.com',
} as const
